export default function Calendaricon() {
    return (
        <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect
                width="13.3333"
                height="15.0834"
                transform="translate(0.333984 0.25)"
                fill="none"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.25073 1V2.00004H1.33398C0.7817 2.00004 0.333984 2.44776 0.333984 3.00004V4.33337V14.3334C0.333984 14.8857
                0.781699 15.3334 1.33398 15.3334H12.6673C13.2196 15.3334 13.6673 14.8857 13.6673 14.3334V4.33337V3.00004C13.6673 2.44776 13.2196
                2.00004 12.6673 2.00004H11.7507V1C11.7507 0.585786 11.4149 0.25 11.0007 0.25C10.5865 0.25 10.2507 0.585786 10.2507
                1V2.00004H3.75073V1C3.75073 0.585786 3.41495 0.25 3.00073 0.25C2.58652 0.25 2.25073 0.585786 2.25073
                1ZM12.6673 5.33337H1.33398V14.3334L12.6673 14.3334V5.33337Z"
                fill="white"
            />
        </svg>
    );
}
